
@switch (columnId) {
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('merchantName') {
    <lib-text-table-column>
      {{ element.merchantName }}
    </lib-text-table-column>
  }
  @case ('feePlanAssociationDate') {
    <lib-date-time-label [dateUtc]="element.associationDateUtc"></lib-date-time-label>
    <lib-table-column-sort [key]="sortingKeyForFeePlanAssociateDate"></lib-table-column-sort>
  }
  @default {
  }
}
